/**
 * Composable for file validation
 * Replaces the validateMimeTypes mixin
 */
export function useFileValidator() {
  const validateMimeTypes = (files: File[], allowedTypes: string[]) => {
    const invalidFiles = files.filter((file) => !allowedTypes.includes(file.type));
    if (invalidFiles.length > 0) {
      return { valid: false, invalidFiles };
    }
    return { valid: true, invalidFiles: [] };
  };

  return { validateMimeTypes };
}
